module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0025.jpg?v=2ee45107";